var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.44 7.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e95c28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3.72,
    cy: 3.72,
    r: 3.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.85,4.96c.03-.05.06-.11.09-.16.02-.04.05-.07.08-.1.07-.08.16-.1.26-.06.28.11.56.22.84.32.04.01.07.03.11.04.09.04.14.11.14.21,0,.4-.29.73-.68.79-.13.02-.25,0-.37-.04-.59-.15-1.1-.43-1.53-.86-.47-.47-.78-1.03-.92-1.68-.1-.46-.1-.93,0-1.39.11-.48.62-.74,1.07-.55.11.05.16.13.16.26-.02.33-.04.66-.05.99,0,.11-.07.19-.17.21-.08.02-.16.03-.24.04-.02,0-.04,0-.06,0,.03.34.13.65.29.95.25.46.62.81.98,1.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/Call Icon.cb93ed1156e907eba68f69fac4f46ae3.svg";
export { ForwardRef as ReactComponent };